import {
    AccessTimeFilled,
    DashboardCustomize, InsertDriveFile,
    Logout, Person, PersonAdd, Receipt, Topic, EmojiPeople, BookOnline, Bookmark, AdminPanelSettings,
    House
} from "@mui/icons-material";

import { LogoutPage } from "@modules/auth";
import { DashboardPage } from "@modules/dashboard";
import { ManagementRequestPage } from "@modules/licenseapplication";
import { ManagementHourPage } from "@modules/timeentry";
import { ManagementInvoicePage } from "@modules/invoice";
import PrivateRoute from "./PrivateRoute";
import { ProfilePage } from "@modules/userprofile";
import { ReferredCommissionPage } from "@modules/commission";
import {
    PeopleAndCulturePage,
    BenefitsPage,
    AdministrationPage,
    FormationPage,
} from "@modules/cms";
import { AdminPage } from "@modules/admin";
import { ManagementReservationPage } from "@modules/reservation";
import type { RouteItem } from "./routes.types";

const routesSidenav: RouteItem[] = [
    {
        type: "title",
        name: "Inicio",
        key: "inicio-title",
        icon: <DashboardCustomize fontSize="small" />,
        route: "/inicioss",
        permission: "Default",
        auth: true,
        component: <DashboardPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "home",
        key: "inicio",
        icon: <DashboardCustomize fontSize="small" />,
        route: "/inicio",
        permission: "Default",
        auth: true,
        component: <DashboardPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "managementInvoice",
        key: "gestion-de-facturas",
        icon: <Receipt fontSize="small" />,
        route: "/gestion-de-facturas",
        auth: true,
        component: <ManagementInvoicePage />,
        permission: "Factura",
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "managementApplication",
        key: "solicitudes",
        icon: <Topic fontSize="small" />,
        route: "/solicitudes",
        permission: "Solicitudes",
        auth: true,
        component: <ManagementRequestPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "managementReservation",
        key: "gestion-de-reservas",
        icon: <House fontSize="small" />,
        route: "/gestion-de-reservas",
        auth: true,
        permission: "Reservas",
        component: <ManagementReservationPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "managementVacancy",
        key: "gestion-de-vacantes",
        icon: <InsertDriveFile fontSize="small" />,
        route: "/gestion-de-vacantes",
        auth: true,
        permission: "Vacantes",
        component: <ManagementInvoicePage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "managementHour",
        key: "gestion-de-horas",
        icon: <AccessTimeFilled fontSize="small" />,
        route: "/gestion-de-horas",
        auth: true,
        permission: "Carga de horas",
        component: <ManagementHourPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "referenced",
        key: "referenciados",
        icon: <PersonAdd fontSize="small" />,
        route: "/referenciados",
        permission: "Vacantes",
        auth: true,
        component: <PrivateRoute><ReferredCommissionPage /></PrivateRoute>,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "administrativePanel",
        key: "panel-administracion",
        icon: <AdminPanelSettings fontSize="small" />,
        route: "/panel-administrativo",
        auth: true,
        permission: "Administración",
        component: <AdminPage />,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
    },
    {
        type: "collapse",
        name: "profile",
        key: "perfil",
        icon: <Person fontSize="small" />,
        route: "/perfil",
        permission: "Default",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL', 'TELEFONICA', 'VISUALIZER'],
        component: <PrivateRoute><ProfilePage /></PrivateRoute>,
    },
    {
        type: "divider",
        name: "Perfil",
        key: "divide",
    },
    {
        type: "collapse",
        name: "People & Culture",
        key: "people-and-culture",
        icon: <EmojiPeople fontSize="small" />,
        route: "/people-and-culture",
        permission: "Default",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PeopleAndCulturePage />,
    },
    {
        type: "collapse",
        name: "administration",
        key: "administracion",
        permission: "Default",
        icon: <BookOnline fontSize="small" />,
        route: "/administracion",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><AdministrationPage /></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "training",
        key: "formacion",
        permission: "Default",
        icon: <DashboardCustomize fontSize="small" />,
        route: "/formacion",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><FormationPage /></PrivateRoute>,
    },
    {
        type: "collapse",
        name: "benefits",
        key: "beneficios",
        permission: "Default",
        icon: <Bookmark fontSize="small" />,
        route: "/beneficios",
        auth: true,
        roles: ['ADMINISTRATOR', 'MANAGER', 'FINANCIAL_CONTROL'],
        component: <PrivateRoute><BenefitsPage /></PrivateRoute>,
    },
    {
        type: "divider",
        name: "Perfil",
        key: "divideLogout",
    },
    {
        type: "collapse",
        name: "logout",
        key: "logout",
        icon: <Logout fontSize="small" />,
        route: "/logout",
        permission: "Default",
        auth: true,
        component: <LogoutPage />,
    },

];

export default routesSidenav;
